import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "../../libs/cn";
import { Spinner } from "./spinner";

// Экран живёт в WebView на телефоне: вместо hover — отклик на нажатие (active:), иначе на
// сенсорном экране подсветка «залипает» после тапа.
const buttonVariants = cva(
  "inline-flex w-full select-none items-center justify-center gap-2 rounded-2xl font-semibold transition-[background-color,transform,opacity] active:scale-[0.98] disabled:pointer-events-none disabled:opacity-40",
  {
    variants: {
      variant: {
        primary: "bg-[var(--color-accent)] text-white active:bg-[var(--color-accent-strong)]",
        secondary:
          "bg-[var(--color-surface)] text-[var(--color-ink)] ring-1 ring-[var(--color-line)] active:bg-[#ece8de]",
        danger: "bg-[var(--color-danger)] text-white active:bg-[#912018]",
        ghost: "w-auto text-[var(--color-muted)] active:bg-black/5",
      },
      size: {
        md: "min-h-14 px-5 text-base",
        lg: "min-h-18 px-6 text-lg",
        sm: "min-h-11 px-3 text-sm",
      },
    },
    defaultVariants: { variant: "primary", size: "md" },
  },
);

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  // Запрос в пути: кнопка заблокирована и крутит индикатор, чтобы повторный тап не ушёл вторым запросом.
  loading?: boolean;
}

export function Button({ className, variant, size, loading, disabled, children, ...props }: ButtonProps) {
  return (
    <button
      className={cn(buttonVariants({ variant, size }), className)}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...props}
    >
      {loading ? <Spinner /> : children}
    </button>
  );
}
